import React, { lazy, Suspense, ReactChild, ReactFragment, ReactPortal } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Loading from '@/components/Loading';
import Router from './Router';

const Vod = lazy(() => import('@/pages/vod'));
const lazyLoad = (
  children: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined,
) => <Suspense fallback={<Loading />}>{children}</Suspense>;

const basename = '/vodplayer';

const App: React.FC = () => {
  
  return (
    <>
      <BrowserRouter basename={basename}>
        <Router routes={(
          <Routes>
            <Route path="/" element={lazyLoad(<Vod />)} />
          </Routes>
        )}
        />
      </BrowserRouter>
    </>
  );
};
export default App;
